<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="680"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Divider orientation="left" class="text-primary">客户信息</Divider>
                    <Col span="24">
                        <FormItem label="客户单位" prop="company">
                            <Input v-model="Forms.company" clearable placeholder="单位名称" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="客户类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable placeholder="客户类型">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.type_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="客户等级" prop="level">
                            <Select v-model="Forms.level" clearable filterable  placeholder="客户等级">
                                <Option v-for="(item,index) in levelList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系人" prop="name">
                            <Input v-model="Forms.name" clearable placeholder="联系人姓名" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="手机号码" prop="mobile">
                            <Input v-model="Forms.mobile" clearable placeholder="联系人电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="微信号" prop="wechat">
                            <Input v-model="Forms.wechat" clearable placeholder="微信号" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="客户邮箱" prop="email">
                            <Input v-model="Forms.email" clearable placeholder="电子邮箱" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="客户地址" prop="address">
                            <Input v-model="Forms.address" clearable placeholder="详细地址" />
                        </FormItem>
                    </Col>

                    <Col span="12">
                        <FormItem label="业务员" prop="saler_id">
                            <Select v-model="Forms.saler_id" clearable filterable  placeholder="业务员">
                                <Option v-for="(item,index) in salerList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="状态：">
                            <RadioGroup v-model="Forms.status" type="button">
                                <Radio :label="1">审核</Radio>
                                <Radio :label="2">禁用</Radio>
                                <Radio :label="3">开启</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                    <Col span="24">
                      <FormItem label="证件资质" prop="image">
                        <Input v-model="Forms.image[0]" disabled>
                          <template #append>
                            <div class="f-center">
                              <Upload
                                  :show-upload-list="false"
                                  :action="upload_url"
                                  :headers = "{'token': $store.state.token}"
                                  :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                  :max-size="50 * 1024"
                                  :on-success="handleSuccess"
                                  :on-format-error="handleFormatError"
                                  :on-exceeded-size="handleMaxSize">
                                <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                              </Upload>
                              <Divider type="vertical" />
                              <a href="javascript:void(0);" @click="FileDelete('image')" class="text-danger"><Icon type="md-trash" />删除</a>
                              <Divider type="vertical" />
                              <a href="javascript:void(0);" @click="FileDownload(Forms.image)" class="text-violet"><Icon type="md-download" />下载</a>
                            </div>
                          </template>
                        </Input>
                      </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="仅内部可见" />
                        </FormItem>
                    </Col>
                    <Divider orientation="left" class="text-primary">发票信息</Divider>
                    <Col span="12">
                        <FormItem label="发票抬头" prop="inv_head">
                            <Input v-model="Forms.inv_head" clearable placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="税号" prop="inv_num">
                            <Input v-model="Forms.inv_num" clearable placeholder="非必填" />
                        </FormItem>
                    </Col>

                    <Col span="12">
                        <FormItem label="电话" prop="inv_phone">
                            <Input v-model="Forms.inv_phone" clearable placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户行" prop="inv_bank">
                            <Input v-model="Forms.inv_bank" clearable placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="银行卡号" prop="inv_bank_card">
                            <Input v-model="Forms.inv_bank_card" clearable placeholder="非必填" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="地址" prop="inv_address">
                            <Input v-model="Forms.inv_address" clearable placeholder="非必填" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>
    </Drawer>
</template>

<script>

import {getCustomerConfig, saveCustomer, getCustomerDetail} from "@/apis/customer";

export default {
    name: 'CustomerCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增客户',
            isBox : false,
            typeList: [],
            levelList: [],
            salerList: [],

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',

            Forms : {
                id: '',
                company: '',
                type_id: '',
                level: '',
                name: '',
                mobile: '',
                wechat: '',
                email: '',
                address: '',
                image: [],
                saler_id: '',
                inv_head: '',
                inv_num: '',
                inv_phone: '',
                inv_bank: '',
                inv_bank_card: '',
                inv_address: '',
                remark: '',
                status: 3
            },
            Rules : {
                company: [
                    { required: true, type: 'string',  message: '请输入客户单位', trigger: 'blur' }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择客户类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                name: [
                    { required: true, type: 'string',  message: '请输入联系人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, type: 'string',  message: '请输入手机号码', trigger: 'blur' }
                ],
                address: [
                    { required: true, type: 'string',  message: '请输入客户地址', trigger: 'blur' }
                ],
                saler_id: [
                    { required: true, type: 'number',  message: '请选择业务员', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
            }
        }
    },
    methods: {
      FileDelete(f){
        let that = this;
        that.Forms[f] = [];
      },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
      /**
       功能：
       time: 2025/12/19 18:12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoDelete(index){
            let that = this;
            that.Forms.image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.image = [res.data.url];
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleBeforeUpload(){
            let that = this;
            if(that.Forms.image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },
        /**
         功能：获取配置
         time: 2025/12/15 11:21
         **/
        GetConfig(){
            let that = this;
            getCustomerConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.levelList = e.data.levelList ?? [];
                that.salerList = e.data.salerList ?? [];
            })
        },

        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getCustomerDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                    if(v === 'status' || v === 'type_id' || v === 'level' || v === 'saler_id' ) {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'image' ) {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025/12/15 11:18
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },

        edit(id){
            this.isBox = true;
            this.title = '编辑客户';
            this.GetConfig();
            if(id) this.GetDetail(id);
        },
        /**
         功能：
         time: 2025/12/15 11:33
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveCustomer(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/15 17:29
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增客户';
            this.$refs['Forms'].resetFields();
            this.Forms.typeList = [];
            this.Forms.levelList = [];
            this.Forms.salerList = [];
            this.Forms.id = '';
            this.Forms.status = 3;
            this.Forms.image = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
